module.exports = __webpack_public_path__ + "media/bell_3.3e881e9f.mp3";